import React from 'react'

const Footer = () => {
  return (
    <footer className="attribution">
        Challenge by <a href="https://www.frontendmentor.io?ref=challenge" rel='noreferrer' target="_blank">Frontend Mentor</a>. 
        Coded by <a href="https://emmanuel-obiora.github.io/portfolio-about-me-/src" rel='noreferrer' target="_blank">Obiora Emmanuel</a>.
  </footer>
  )
}

export default Footer